<div class="toggle" *ngIf="showApplyAll">
  <div>
    <span class="toggle-txt">{{ "paxForms.usPerson.toggle_txt" | translate }}</span>
  </div>
  <div class="toggle-container" [class.is-on]="isOn" (click)="toggle()">
    <div class="toggle-container-value" [class.is-on-change]="isOn">

    </div>
  </div>
</div>